export const HotelOverviewText = 'ЗА ХОТЕЛА';
// export const BaseUrl = "http://localhost:8080";
// export const BaseUrl = "https://127.0.0.1:8080";
// export const BaseUrl = "https://78.128.6.13:8443";
export const BaseUrl = "https://bakalov2002.com:8443";